<template>
    <div class="animated fadeIn">
      <b-button
        type="button"
        size="sm"
        variant="primary"
        v-on:click="addPerson"
        :disabled="disabled"
      ><i class="fa fa-plus" ></i>Add
      </b-button>
    </div>
</template>
<script>
    import {RepositoryFactory} from "../../../services/repositories/RepositoryFactory";
    import {handleErrors} from "../../../shared/utils";
    import {Person} from "../../../models/Person";
    import router from "../../../router";

    const PersonRepo = RepositoryFactory.get('people');

    export default {
        name: 'person-add-button',
        props: {
            person: {
                type: Object,
                default: new Person(),
            },
          disabled: {
              type: Boolean,
              default: false,
          }
        },
        methods: {
            addPerson() {
                this.$emit('click')
                this.disabled = true
                PersonRepo
                    .createPerson(this.person)
                    .then(
                        response =>
                            (
                                router.push({name: 'person', params: {person_id: response.data.data.id}})
                            )
                    )
                    .catch(
                        response => (
                            this.returnErrors(response)
                        )
                    )
            },
            returnErrors(response) {
                handleErrors(response).forEach(
                    value => {
                        this.flash(value,'error')
                    }
                )
                this.disabled = false
                this.$emit('click')
            },
        },
    }
</script>
